const $ = jQuery;

class StickyPageNav {
	constructor() {
		this.block = document.querySelector('.block-sticky-page-nav');
		if (null === this.block) {
			return;
		}

		this.scroller = document.querySelector('.block-sticky-page-nav__scroller');
		this.lastPosition = 0;

		this.checkOverflow();
		window.addEventListener('load', this.checkOverflow.bind(this));
		window.addEventListener('resize', this.checkOverflow.bind(this), { passive: true });
		window.addEventListener('scroll', this.checkIsSticking.bind(this), { passive: true });

		this.scroller
			.querySelector('.block-sticky-page-nav__list')
			.addEventListener('scroll', () => this.setScrollClasses(this.scroller));
	}

	checkIsSticking() {
		const scrollTop = $(this.block).offset().top;

		document.body.classList.toggle('page-nav-sticking', this.lastPosition !== scrollTop);
		this.lastPosition = scrollTop;
	}

	setScrollClasses(scroller) {
		const listInner = scroller.querySelector('.block-sticky-page-nav__list');
		if (listInner.offsetWidth < listInner.scrollWidth) {
			scroller.classList.add('has-scroll');

			if (0 !== listInner.scrollLeft) {
				scroller.classList.add('has-scroll-left');
			} else {
				scroller.classList.remove('has-scroll-left');
			}

			if (Math.ceil(listInner.scrollLeft) + listInner.offsetWidth !== listInner.scrollWidth) {
				scroller.classList.add('has-scroll-right');
			} else {
				scroller.classList.remove('has-scroll-right');
			}
		} else {
			scroller.classList.remove('has-scroll');
		}
	}

	checkOverflow() {
		this.setScrollClasses(this.scroller);
	}
}

new StickyPageNav();
